module.exports = __webpack_public_path__ + "media/fail.186edf68.mp3";